import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Clock, Mail } from 'lucide-react';

const PendingScreen = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-950 via-green-950 to-emerald-950 flex items-center justify-center px-4">
    <div className="max-w-md w-full bg-white/10 backdrop-blur-xl border-2 border-white/20 rounded-3xl p-8 text-center">
      <div className="w-16 h-16 bg-gradient-to-br from-orange-400 to-amber-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
        <Clock className="w-8 h-8 text-white" />
      </div>
      <h2 className="text-2xl font-bold text-white mb-2">Compte en attente</h2>
      <p className="text-white/60 text-sm mb-6">
        Votre numéro RPPS est en cours de vérification. Vous recevrez un email dès que votre accès Pro est activé.
      </p>
      <div className="bg-white/5 border border-white/10 rounded-xl p-4">
        <div className="flex items-center gap-2 justify-center text-white/70 text-sm">
          <Mail className="w-4 h-4" />
          <span>Vérification sous 24-48h</span>
        </div>
      </div>
    </div>
  </div>
);

const ProfessionalRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) return <Navigate to="/auth/pro" replace />;

  if (!['infirmier', 'medecin'].includes(user?.profile_type)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (user?.status === 'pending' || !user?.status) {
    return <PendingScreen />;
  }

  if (user?.status === 'rejected') {
    return <Navigate to="/auth/pro" replace />;
  }

  return children;
};

export default ProfessionalRoute;
